/* tslint:disable */
/* eslint-disable */
/**
 * Locations Api Documentation
 * Locations Microservice is a High Availability API built to search for locations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * The channel of the request.
 * @export
 * @enum {string}
 */

export const Channel = {
    AgentTerminal: 'AGENT_TERMINAL',
    WebBrowser: 'WEB_BROWSER',
    AirportKiosk: 'AIRPORT_KIOSK',
    MobileWeb: 'MOBILE_WEB',
    MobileApp: 'MOBILE_APP',
    Other: 'OTHER',
    Unknown: 'UNKNOWN'
} as const;

export type Channel = typeof Channel[keyof typeof Channel];


/**
 *
 * @export
 * @interface ChildError
 */
export interface ChildError {
    /**
     *
     * @type {string}
     * @memberof ChildError
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof ChildError
     */
    'businessMessage'?: string;
    /**
     *
     * @type {string}
     * @memberof ChildError
     */
    'developerLink'?: string;
}
/**
 *
 * @export
 * @interface ErrorError
 */
export interface ErrorError {
    /**
     *
     * @type {string}
     * @memberof ErrorError
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof ErrorError
     */
    'businessMessage'?: string;
    /**
     *
     * @type {string}
     * @memberof ErrorError
     */
    'developerLink'?: string;
    /**
     *
     * @type {Array<ChildError>}
     * @memberof ErrorError
     */
    'childError'?: Array<ChildError>;
}

/**
 *
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * The Location\'s ID
     * @type {string}
     * @memberof Location
     */
    'id': string;
    /**
     * The Vendor\'s BrandId - an identifier for the used search type (CAR_HIRE, EXPERIENCE, HOTEL)
     * @type {string}
     * @memberof Location
     */
    'vendorBrandId'?: string;
    /**
     * The Location\'s type
     * @type {string}
     * @memberof Location
     */
    'type'?: string;
    /**
     * The Location\'s name
     * @type {string}
     * @memberof Location
     */
    'name': string;
    /**
     * The Location\'s full name
     * @type {string}
     * @memberof Location
     */
    'fullName': string;
    /**
     * The Location\'s country code
     * @type {string}
     * @memberof Location
     */
    'countryCode'?: string;
    /**
     * The address of property
     * @type {string}
     * @memberof Location
     */
    'address'?: string;
    /**
     * The email-address of property
     * @type {string}
     * @memberof Location
     */
    'emailAddress'?: string;
    /**
     *
     * @type {boolean}
     * @memberof Location
     */
    'afterHoursIndicator'?: boolean;
    /**
     * The telephone number of property
     * @type {string}
     * @memberof Location
     */
    'telephoneNumber'?: string;
    /**
     *
     * @type {Array<OpeningTimes>}
     * @memberof Location
     */
    'openingTimes'?: Array<OpeningTimes>;
    /**
     *
     * @type {Array<LocationMeasures>}
     * @memberof Location
     */
    'location'?: Array<LocationMeasures>;
    /**
     * car hire vendor brandId (AVIS=3, BUDGET=4)
     * @type {string}
     * @memberof Location
     */
    'brandId'?: string;
    /**
     * The car hire brands available at this location, with the details that differ per brand. Populated for CAR_HIRE searches on every location, whether it serves one brand or two, so a consumer can compute the brands two locations have in common.
     * @type {Array<LocationVendor>}
     * @memberof Location
     */
    'vendors'?: Array<LocationVendor>;
}
/**
 * One car hire brand\'s desk at a location.
 * @export
 * @interface LocationVendor
 */
export interface LocationVendor {
    /**
     * car hire vendor brandId (AVIS=3, BUDGET=4)
     * @type {string}
     * @memberof LocationVendor
     */
    'brandId': string;
    /**
     * The brand\'s own name for the location
     * @type {string}
     * @memberof LocationVendor
     */
    'name'?: string;
    /**
     * The address of this brand\'s desk
     * @type {string}
     * @memberof LocationVendor
     */
    'address'?: string;
    /**
     * The email-address of this brand\'s desk
     * @type {string}
     * @memberof LocationVendor
     */
    'emailAddress'?: string;
    /**
     * The telephone number of this brand\'s desk
     * @type {string}
     * @memberof LocationVendor
     */
    'telephoneNumber'?: string;
    /**
     * Whether this brand supports an after-hours key drop at this location
     * @type {boolean}
     * @memberof LocationVendor
     */
    'afterHoursIndicator'?: boolean;
    /**
     * This brand\'s own opening times
     * @type {Array<OpeningTimes>}
     * @memberof LocationVendor
     */
    'openingTimes'?: Array<OpeningTimes>;
    /**
     * This brand\'s own coordinates
     * @type {Array<LocationMeasures>}
     * @memberof LocationVendor
     */
    'location'?: Array<LocationMeasures>;
}
/**
 *
 * @export
 * @interface LocationMeasures
 */
export interface LocationMeasures {
    /**
     * The longitude measure
     * @type {string}
     * @memberof LocationMeasures
     */
    'longitude': string;
    /**
     * The latitude measure
     * @type {string}
     * @memberof LocationMeasures
     */
    'latitude': string;
}
/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     *
     * @type {ErrorError}
     * @memberof ModelError
     */
    'error'?: ErrorError;
}
/**
 *
 * @export
 * @interface OpeningTimes
 */
export interface OpeningTimes {
    /**
     * Opening day
     * @type {string}
     * @memberof OpeningTimes
     */
    'day': string;
    /**
     * Openeing times
     * @type {Array<string>}
     * @memberof OpeningTimes
     */
    'hours': Array<string>;
}
/**
 * Partner\'s Iata code
 * @export
 * @enum {string}
 */

export const Partner = {
    Ei: 'EI',
    Vy: 'VY',
    Ba: 'BA',
    Ib: 'IB'
} as const;

export type Partner = typeof Partner[keyof typeof Partner];

/**
 * Type of Ancillary
 * @export
 * @enum {string}
 */

export const SearchType = {
    CarHire: 'CAR_HIRE',
    Experience: 'EXPERIENCE',
    Hotel: 'HOTEL'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];

/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary List locations
         * @param {SearchType} searchType Type of Ancillary
         * @param {Partner} partner
         * @param {Channel} channel
         * @param {string} languageCode
         * @param {string} [searchString] Value to search (required if latitude &amp; longitude are not provided)
         * @param {string} [latitude] Latitude coordinate in decimal degrees
         * @param {string} [longitude] Longitude coordinate in decimal degrees
         * @param {string} [xSearchEngine] Type of search engine (as header)
         * @param {string} [xCorrelationId] Correlation id for logs (as header)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocations: async (searchType: SearchType, partner: Partner, channel: Channel, languageCode: string, searchString?: string, latitude?: string, longitude?: string, xSearchEngine?: string, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchType' is not null or undefined
            assertParamExists('searchLocations', 'searchType', searchType)
            // verify required parameter 'partner' is not null or undefined
            assertParamExists('searchLocations', 'partner', partner)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('searchLocations', 'channel', channel)
            // verify required parameter 'languageCode' is not null or undefined
            assertParamExists('searchLocations', 'languageCode', languageCode)
            const localVarPath = `/locations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (partner !== undefined) {
                localVarQueryParameter['partner'] = partner;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            if (xSearchEngine !== undefined && xSearchEngine !== null) {
                localVarHeaderParameter['X-Search-Engine'] = String(xSearchEngine);
            }

            if (xCorrelationId !== undefined && xCorrelationId !== null) {
                localVarHeaderParameter['x-correlation-id'] = String(xCorrelationId);
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary List locations
         * @param {SearchType} searchType Type of Ancillary
         * @param {Partner} partner
         * @param {Channel} channel
         * @param {string} languageCode
         * @param {string} [searchString] Value to search (required if latitude &amp; longitude are not provided)
         * @param {string} [latitude] Latitude coordinate in decimal degrees
         * @param {string} [longitude] Longitude coordinate in decimal degrees
         * @param {string} [xSearchEngine] Type of search engine (as header)
         * @param {string} [xCorrelationId] Correlation id for logs (as header)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocations(searchType: SearchType, partner: Partner, channel: Channel, languageCode: string, searchString?: string, latitude?: string, longitude?: string, xSearchEngine?: string, xCorrelationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Location>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocations(searchType, partner, channel, languageCode, searchString, latitude, longitude, xSearchEngine, xCorrelationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         *
         * @summary List locations
         * @param {SearchType} searchType Type of Ancillary
         * @param {Partner} partner
         * @param {Channel} channel
         * @param {string} languageCode
         * @param {string} [searchString] Value to search (required if latitude &amp; longitude are not provided)
         * @param {string} [latitude] Latitude coordinate in decimal degrees
         * @param {string} [longitude] Longitude coordinate in decimal degrees
         * @param {string} [xSearchEngine] Type of search engine (as header)
         * @param {string} [xCorrelationId] Correlation id for logs (as header)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocations(searchType: SearchType, partner: Partner, channel: Channel, languageCode: string, searchString?: string, latitude?: string, longitude?: string, xSearchEngine?: string, xCorrelationId?: string, options?: any): AxiosPromise<Array<Location>> {
            return localVarFp.searchLocations(searchType, partner, channel, languageCode, searchString, latitude, longitude, xSearchEngine, xCorrelationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     *
     * @summary List locations
     * @param {SearchType} searchType Type of Ancillary
     * @param {Partner} partner
     * @param {Channel} channel
     * @param {string} languageCode
     * @param {string} [searchString] Value to search (required if latitude &amp; longitude are not provided)
     * @param {string} [latitude] Latitude coordinate in decimal degrees
     * @param {string} [longitude] Longitude coordinate in decimal degrees
     * @param {string} [xSearchEngine] Type of search engine (as header)
     * @param {string} [xCorrelationId] Correlation id for logs (as header)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public searchLocations(searchType: SearchType, partner: Partner, channel: Channel, languageCode: string, searchString?: string, latitude?: string, longitude?: string, xSearchEngine?: string, xCorrelationId?: string, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).searchLocations(searchType, partner, channel, languageCode, searchString, latitude, longitude, xSearchEngine, xCorrelationId, options).then((request) => request(this.axios, this.basePath));
    }
}

